// Lokaler Fortschritt im Browser (keine Daten verlassen das Gerät).
// localStorage kann fehlen oder werfen (privates Fenster) -- dann läuft alles ohne Speichern.

import type { Flow } from "./sim.ts";

const PREFIX = "flowlab:";

function get<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw === null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

function set(key: string, value: unknown): void {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    /* ohne Speicher weiterarbeiten */
  }
}

export const store = {
  flow: (taskId: string): Flow | null => get<Flow | null>(`flow:${taskId}`, null),
  saveFlow: (taskId: string, f: Flow) => set(`flow:${taskId}`, f),
  hints: (taskId: string): number => get(`hints:${taskId}`, 0),
  saveHints: (taskId: string, n: number) => set(`hints:${taskId}`, n),
  stars: (): Record<string, number> => get("stars", {}),
  /** Speichert nur Verbesserungen; liefert true, wenn es ein neuer Bestwert ist. */
  saveStars(taskId: string, n: number): boolean {
    const all = this.stars();
    if ((all[taskId] ?? 0) >= n) return false;
    all[taskId] = n;
    set("stars", all);
    return true;
  },
  /** Löscht Sterne, Diagramme und Hinweise; die client_id bleibt (sonst zählt das Dashboard doppelt). */
  clearProgress(): void {
    try {
      const keys = Object.keys(localStorage).filter(k => k.startsWith(PREFIX) && k !== `${PREFIX}client`);
      keys.forEach(k => localStorage.removeItem(k));
    } catch {
      /* nichts gespeichert, nichts zu löschen */
    }
  },
};
